import isString from 'lodash/isString';

export const truncate = (string, {length = 100, appendString = '...'} = {}) => {
  if (!isString(string)) return '';
  if (string.length <= length) return string;
  let cleanStr = string.slice(0, length - 1);
  cleanStr += appendString;
  return cleanStr;
};

export const capitalize = (string) => {
  return string.charAt(0).toUpperCase() + string.slice(1);
};

export const formatPhoneNumber = (phoneNumber) => {
  if (!phoneNumber) return '';
  let cleanPhone = '(' + phoneNumber.slice(0,3) + ') ';
  cleanPhone += phoneNumber.slice(3,6) + '-';
  cleanPhone += phoneNumber.slice(6,10);
  return cleanPhone;
};